<template>
    <div id="device-gantt" >
        <div  style="padding:0px 10px;background:#fff">
            <el-row class='tab'>
                <div class="gantt-list">
                    <div class="tab-head">
                        <div class="table_searchbar">
                            <el-row :gutter="W?20:0">
                                <el-col :span="11" style="display:flex">
                                    <div class="" @keydown.enter="clickSearch()">
                                        <span class="title">开始时间：</span>
                                        <el-date-picker   style="width:230px" v-model="searchForm.planTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                                    </div>
                                </el-col>
                                <el-col :span="11" style="display:flex">
                                    <div class="" @keydown.enter="clickSearch()">
                                        <span class="title">交付时间：</span>
                                        <el-date-picker   style="width:230px" v-model="searchForm.payTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:16px">
                                <el-col :span='6'>
                                    <div>
                                        <span class="title">订单号：</span>
                                        <el-select style="max-width:180px" @change="orederSelect" filterable="filterable" clearable="clearable" remote :remote-method="remoteOrder"  v-model='searchForm.orderId' size='small' maxlength='16' placeholder='订单号' popper-class='width180'>
                                            <el-option v-for="item in orderOptions" :key="item.orderId" :value="item.orderId" :label="item.orderCode"></el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span='6'>
                                    <div>
                                        <span class="title">物料名称：</span>
                                        <el-select style="max-width:180px" filterable="filterable" clearable="clearable"   v-model='searchForm.materialId' size='small' maxlength='16' placeholder='物料名称'
                                            remote :remote-method="query=>remoteMethod(query)" popper-class='width180'>
                                            <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialName"></el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span='6'>
                                    <div>
                                        <span class="title">物料编码：</span> 
                                        <el-select style="max-width:180px" filterable="filterable" clearable="clearable"   v-model='searchForm.materialId' size='small' maxlength='16' placeholder='物料编码'
                                            remote :remote-method="query=>remoteMethod('',query)"  popper-class='width180'>
                                            <el-option v-for="item in materialList" :key="item.materialId" :value="item.materialId" :label="item.materialCode"></el-option>
                                        </el-select>
                                    </div>
                                </el-col>
                                <el-col :span="6" >
                                    <div style="text-align:right">
                                        <el-button icon="el-icon-search" size='mini' type="primary" @click="search">查询</el-button>
                                        <el-button icon="el-icon-refresh" size='mini'  @click="clearSearch">重置</el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="right-item">
                            <div class="explain">
                                <div class="explain-item">
                                    <span>缩放甘特图</span>
                                    <el-slider style="width:360px;margin-top: -10px;margin-left: 20px;" v-model="baseW" :min='30' :max="150"></el-slider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="overflow: hidden;display:flex">
                        <div class="left-warp">
                            <div class="left-head">
                                <div class="item border" style="width:140px;border-right:none">
                                    <span>订单号/订单行</span>
                                </div>
                                <div class="item border" style="width:200px;">
                                    <span>物料信息</span>
                                </div>
                            </div>
                            <div class="left-body" :style="{top:`${top}px`}" >
                                <div class="devcie-info" >
                                    <div v-for="item in selectOrderList" :key="item.id" style="display:flex;height:74px" class="device-item">
                                        <div v-if="item.leyer==1" class="item border" :style="item.isOpen?{borderRight: 'none',borderBottom: 'none',width:'140px'}:{borderRight: 'none',width:'140px'}" @click="showSub(item)">
                                            <i style="font-size: 20px;color: rgb(0, 197, 210);background: rgb(254,243,210);" :class="item.isOpen?['el-icon-folder-remove']:['el-icon-folder-add']"></i>
                                            <span>{{item.orderLine}}</span>
                                        </div>
                                        <div v-else class="item border" style="border-right: none;border-top: none;border-bottom:none;width:140px;"></div>
                                        <div style="display:flex;width:200px;border-right: none;border-top: none;box-sizing: border-box; font-size:12px" :class="item.leyer==1?['border','item-bg']:['border']">
                                            <div style="width:160px;text-align: center;align-self: center;">
                                                <el-tooltip  effect="dark" :content="`${item.materialCode}/${item.materialName}`" placement="top">
                                                    <span  style="display:inline-block;width:100%;line-height:22px ">{{item.materialCode}}/{{item.materialName}}</span>
                                                </el-tooltip>
                                                <span style="display:inline-block;width:100%;line-height:22px">数量:{{item.leyer==1?item.itemCount:item.splitCount}}</span>
                                                <span v-if="item.leyer==1" style="display:inline-block;width:100%;line-height:22px">交付日期:{{item.deliverTime|filterPay}}</span>
                                            </div>
                                            <div style="width:37px;box-sizing: border-box;">
                                                <span class="plan-text border" >计划</span>
                                                <span class="plan-text border">实际</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-warp scrollbar" id="right-warp">
                            <div class="right-content" :style="{width:`${baseW*dayLen}px`}">
                                <div  class="table-time-warp border" >
                                    <div v-for="(item,index) in monthDay" :key='index' :style="{width:`${baseW*item.dayList.length}px`}">
                                        <div style="text-align: center;line-height:37px;text-align: center;border-right:1px solid rgb(220,223,230) ">
                                            <span>{{item.month|filterMonth(dayLen,baseW,showHours)}}</span>
                                        </div>
                                        <div style="display:flex">
                                            <div v-for="(dayItem,index1) in item.dayList" :key="dayItem" class="border day-item" :style="index1==0&&index==0?{borderLeft:'none',width:`${baseW}px`}:{width:`${baseW}px`}">
                                                <span>{{dayItem|filterDay(dayLen,baseW,showHours)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="bar-warp" ref="right-scroll" @scroll="scrollEvent">
                                    <div :style="{height:`${baseHeight*selectOrderList.length}px`, position: 'relative'}" >
                                        <div v-for="(item,tIndex) in taskList" :key="tIndex"  class="bar" :style="{width:`${item.w}px`,height:`${item.h}px`,left:`${item.x}px`,top:`${item.y}px`,zIndex:item.zIndex,background:item.color}">
                                            <el-popover placement="top" maxWidth="600" trigger="click" @show="itemClick(item)">
                                                
                                                <div class="detail-warp">
                                                    <div class="detail-item detail-head">
                                                        <div><span>工单号</span></div>
                                                        <div><span>数量</span></div>
                                                        <div><span>计划时间</span></div>
                                                        <div><span>实际时间</span></div>
                                                    </div>
                                                    <div class="detail-item detail-body" v-for="(d,di) in detail" :Key='Math.random()+di'>
                                                        <div><span>{{d.productionBatchCode}}</span></div>
                                                        <div><span>{{d.amount}}</span></div>
                                                        <div><span>{{d.planTime}}</span></div>
                                                        <div><span>{{d.actualTime}}</span></div>
                                                    </div>
                                                </div>
                                                
                                                <div slot="reference" style="width:100%;height:100%" ></div>
                                            </el-popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>


export default {
    name: "OrderGantt",
    data() {
        return {
            detail:[],
            baseW:60, //默认1天宽度为60px
            minDate:'',
            maxDate:'',
            top:0,
            orderList:[],
            materialList:[],
            pickerBeginDateBefore:{
                onPick:({maxDate,minDate})=>{
                    log(maxDate,minDate,this.dateRange,666)
                    this.minDate=minDate;
                    this.maxDate=maxDate;
                },
                disabledDate:time=> {
                    if(this.minDate){
                        return time.getTime() > this.minDate.getTime() + 14*60*60*24*1000
                    }else{
                        return false
                    }
                }
            },
            activeIndex:2,
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            data:[
                
            ],
            dateRange:[],
            allWorkerSelect:[],
            taskList:[],
            selectOrderList:[],
            dayLen:7,
            monthDay:[
                {
                   dayList:[],
                   month:'', 
                }
            ],
            showHours:false,
            orderOptions:[],
            colorList1:['rgb(90,225,255)', 'rgb(177,237,241)','rgb(224,242,216)','rgb(255,235,177)'],
            colorList2:['rgb(64,158,255)', 'rgb(0,197,210)','rgb(154,214,129)','rgb(255,190,0)'],
            startTime:'2020-09-25',
            endTime:'2020-10-08',
            baseHeight:74,   //设置每个单个表格高度
            maxWeight:1160,   //设备最大宽度
            orderList:[],
            deviceUserInfoCopy:[],
            linkList:[],
            loading:false,
            userList:[],
            deviceList:[],
            webSearchStr:'',
            searchForm:{
                orderId:null,
                materialId:null,
                planTime:[],
                payTime:[],
            },
            week:{0:'日', 1:'一', 2:'二', 3:'三', 4:'四', 5:'五', 6:'六', },
            tasks: {
                data: []
            },
            tableTotalPage:0,
            tableCurrentPage:1,
            fristLoad:false,
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            W:false,
            // dateRange: [new Date(this.startTime), new Date(this.endTime)],
            permission:JSON.parse(localStorage.getItem("permission"))
        };
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    filters:{
        filterMonth(str,len,w,showHours){
            log(showHours,4444)
            if(w>=70||showHours){
                return str
            }
            if(len>3){
                
                let [y,m]= str.split('-')
                y = (''+y).slice(2)
                return y+'年'+Number.parseInt(m) + '月'
            }else{
               return str
            }
        },

        filterDay(str,len,w,showHours){
            if(w>=70||showHours){
                return str
            }
            if(len>3){
                str = str.split('-')[2] 
                return Number.parseInt(str)+'日'
            }else{
                return str
            }
        },

        filterPay(val){
            if(!val){
                return ''
            }
            if(val.length>12){
                return val.split(' ')[0]
            }
        },
    },
    beforeDestroy(){
       
    },
    mounted: async function() {
        window.status=1
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        
        this.search()
        await this.loadOrderList()
    },
    watch:{
        baseW(oldV,newV){
            this.computedBarPostion()
        },
    },
    methods: {
        scrollEvent(ev){
            this.top = -this.$refs['right-scroll'].scrollTop
        },
        
        showSub(item){
            item.isOpen = !item.isOpen
            this.orderList.forEach((o,i)=>{
                if(o.orderItemId==item.orderItemId){
                    
                    o.isOpen = item.isOpen
                    log(o,i,item.isOpen,!item.isOpen,10010)
                }
            })
            this.computedBarPostion()
        },

        initDayList(startTime, endTime,w){
            let {len,monthDay,showHours} = commonUtils.getMonthDay(startTime,endTime,w) 
            this.showHours = showHours
            this.dayLen = len
            this.monthDay = monthDay
        },

        selectData(e){
            this.minDate = ''
            this.maxDate = ''
        },

        selectTimeChange(){
            let {len,monthDay,showHours} = commonUtils.getMonthDay(this.startTime,this.endTime) 
            this.dayLen = len
            this.monthDay = monthDay
            this.showHours = showHours
            this.computedBarPostion()
        },

        

        computedBarPostion(){
            //找到minStartDay 和 maxEndDay
            let timeList = []
            this.orderList.forEach((item,i)=>{
                
                if(item.planStartTime){
                    timeList.push(this.dateTotimestamp(item.planStartTime))
                }
                if(item.planEndTime){
                    timeList.push(this.dateTotimestamp(item.planEndTime))
                }
                timeList.push(this.dateTotimestamp(item.actualEndTime))
                timeList.push(this.dateTotimestamp(item.actualStartTime))
                
            })
            let minStartDay = commonUtils.timestampToDate(timeList.sort((n1,n2)=>n1-n2)[0],true)
            let maxEndDay = commonUtils.timestampToDate(timeList.sort((n1,n2)=>n2-n1)[0],true)
            
            if(this.baseW>=70){
                this.initDayList(minStartDay,maxEndDay,this.baseW)
            }else{
                this.initDayList(minStartDay,maxEndDay)
            }
            if(this.dateTotimestamp(minStartDay)<this.dateTotimestamp(this.startTime)){
                let len = commonUtils.formatEveryDay(minStartDay,this.startTime).length
                this.$nextTick(()=>{
                    document.querySelector('#right-warp').scrollLeft = len*this.baseW
                    
                })
            }
            
            let taskList = []
            let count1 = 0
            let count2 = 0
            let iow = new Date().getTime()
            let len = 0
            let selectOrderList = []
            let width = 24*60*60*1000
            if(this.dayLen<=3||this.baseW>=70){
                width = 4*60*60*1000
            }
            if(this.baseW>=85){
                width = 2*60*60*1000
            }
            if(this.baseW>=100){
                width = 1*60*60*1000
            }
            this.orderList.forEach((item,index)=>{
                let x = (this.dateTotimestamp(item.planStartTime) - this.dateTotimestamp(minStartDay))*this.baseW/width
                let w = 0
                if(item.planEndTime&&item.planStartTime){
                    w = (this.dateTotimestamp(item.planEndTime) - this.dateTotimestamp(item.planStartTime))*this.baseW/width
                }
                
                let h = 18
                let y = len*this.baseHeight + 15
                let color = this.colorList1[count1%this.colorList1.length]
                count1++
                let json = {
                    ...item,
                    x:Number.parseInt(x),
                    y:Number.parseInt(y),
                    w:Number.parseInt(w),
                    h:Number.parseInt(h),
                    color,
                }
                
                taskList.push(json)
                selectOrderList.push(item)
                let x1 = (this.dateTotimestamp(item.actualStartTime) - this.dateTotimestamp(minStartDay))*this.baseW/width
                let w1 = (this.dateTotimestamp(item.actualEndTime) - this.dateTotimestamp(item.actualStartTime))*this.baseW/width
                if(!item.actualEndTime){
                    w1 = (iow - this.dateTotimestamp(item.actualStartTime))*this.baseW/width
                }
                let h1 = 26
                let y1 = len*this.baseHeight + 40
                let color1 = this.colorList2[count2%this.colorList2.length]
                count2++

                taskList.push({
                    ...item,
                    len:item.splitGroupMaterialDtos.length,
                    leyer:1,
                    x:Number.parseInt(x1),
                    y:Number.parseInt(y1),
                    w:Number.parseInt(w1),
                    h:Number.parseInt(h1),
                    color:color1,
                })
                len++
                if(item.isOpen){
                    item.splitGroupMaterialDtos.forEach((t,tIndex)=>{
                        selectOrderList.push(t)
                        let tx = (this.dateTotimestamp(t.planStartTime) - this.dateTotimestamp(minStartDay))*this.baseW/width
                        let tw = 0
                        if(t.planEndTime&&t.planStartTime){
                            tw = (this.dateTotimestamp(t.planEndTime) - this.dateTotimestamp(t.planStartTime))*this.baseW/width
                        }
                        
                        let th = 18
                        let ty = len*this.baseHeight + 15
                        let tcolor = this.colorList1[count1%this.colorList1.length]
                        count1++
                        taskList.push({
                            ...t,
                            leyer:2,
                            orderItemId:item.orderItemId,
                            x:Number.parseInt(tx),
                            y:Number.parseInt(ty),
                            w:Number.parseInt(tw),
                            h:Number.parseInt(th),
                            color:tcolor,

                        })

                        let tx1 = (this.dateTotimestamp(t.actualStartTime) - this.dateTotimestamp(minStartDay))*this.baseW/width
                        let tw1 = (this.dateTotimestamp(t.actualEndTime) - this.dateTotimestamp(t.actualStartTime))*this.baseW/width
                        if(!t.actualEndTime){
                            tw1 = (iow - this.dateTotimestamp(t.actualStartTime))*this.baseW/width
                        }
                        let th1 = 26
                        let ty1 = len*this.baseHeight + 40
                        let tcolor1 = this.colorList2[count2%this.colorList2.length]
                        count2++
                        taskList.push({
                            ...t,
                            leyer:2,
                            orderItemId:item.orderItemId,
                            x:Number.parseInt(tx1),
                            y:Number.parseInt(ty1),
                            w:Number.parseInt(tw1),
                            h:Number.parseInt(th1),
                            color:color1,
                        })
                        len++
                    })
                }
                
                
            })
            this.selectOrderList = selectOrderList
            this.taskList = taskList
        },
     
        dateTotimestamp(timeStr){
            if(!timeStr){
                return
            }
            if(timeStr.length<12){
                timeStr = timeStr.trim() + ' 00:00:00'
            }
            return new Date(timeStr).getTime()
        },

        

        async remoteOrder(query){
            this.loading = true
            await this.loadOrderList(query)
            this.loading = false
        },

        async loadOrderList(orderCode){
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/orderList',  params: { orderCode}, })
            this.orderOptions = data
        },

        async remoteMethod(materialName,materialCode){
            this.loading = true;
            await this.loadMaterialList(materialName,materialCode)

			this.loading = false
        },

        async orederSelect(){
            this.searchForm.materialId = null
            await this.loadMaterialList()
        },

        async loadMaterialList(materialName,materialCode){
			let res = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialByOrderItem',params: {materialName,materialCode,orderId:this.searchForm.orderId},});
			if(res.code == 0){
				this.materialList = res.data;
			}
        },
        
        clearSearch() {
            let form = this.searchForm;
            form.materialId = null
            form.planTime = []
            form.payTime = []
            form.orderId = null
        },
      
        search:function(){
            let deliverStartTime,deliverEndTime,planStartTime,planEndTime
            if(this.searchForm.planTime&&this.searchForm.planTime.length==2){
                planStartTime = this.searchForm.planTime[0]
                planEndTime = this.searchForm.planTime[1]
            }
            if(this.searchForm.payTime&&this.searchForm.payTime.length==2){
                deliverStartTime = this.searchForm.payTime[0]
                deliverEndTime = this.searchForm.payTime[1]
            }
            this.$RequestUtil.get({
                url:'/api/order/ganttChartList',
                type:'sync',
                params: {
                    orderId:this.searchForm.orderId,
                    materialId:this.searchForm.materialId,
                    deliverStartTime,
                    deliverEndTime,
                    planStartTime,
                    planEndTime,
                },
                success: (res) => {
                    if(res.code == 0){
                        res.data.forEach((item,i)=>{
                            item.isOpen=false
                            if(i==0){
                                item.isOpen=true
                            }
                            item.len = item.splitGroupMaterialDtos.length
                            item.leyer = 1
                        })
                        this.orderList = res.data
                        this.computedBarPostion()
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
        async itemClick(item){
            
            await this.loadDatail(item.orderItemId,item.materialId)
           
        },

        async loadDatail(orderItemId,materialId){
           let {data,code} =  await this.$RequestUtil.getAsync({url: '/api/order/listSplitByItemAndMaterial',params: {orderItemId,materialId},});
            data.forEach(item=>{

                item.planTime = this.parseShowTime(item.planStartTime) + ' —— '+this.parseShowTime(item.planEndTime)
                item.actualTime = this.parseShowTime(item.actualStartTime) + ' —— '+this.parseShowTime(item.actualEndTime)
            })
            this.detail = data
        },
        parseShowTime(val){
            if(!val){
                return ''
            }
            if(val.length>12){
                return val.split(' ')[0]
            }
        }
    },
    activated(){
    
    }

};
</script>

<style scoped>
    .scrollbar::-webkit-scrollbar { 
        width:8px; 
        height:12px; 
        background:#ccc; 
        border-radius:10px;/*外层轨道*/
    }
    .scrollbar::-webkit-scrollbar-thumb{ /*内层轨道*/
        display:block; 
        width:6px; 
        margin:0 auto; 
        border-radius: 10px; 
        background:rgba(255, 192, 66, 0.5);
    }

    .left-warp{
        width: 340px;
        height: 100%;
    }
    .left-head{
        width: 100%;
        display: flex;
        position: relative;
        z-index: 3;
        background: white;
    
    }
    .item-bg{
        background: #ccc;
    }
    .right-warp{
        max-width: 1300px;
        overflow: auto;
        height: 100%;
        overflow-y: hidden;
        border-right: 1px solid #ccc;
    }


    .left-body{
        height: 560px;
        /* overflow: hidden; */
        position: relative;
        z-index: 2;
    }
    .bar-warp{
        overflow: hidden;
        overflow-y: auto;
        max-height: 560px;
    }
    .bar-warp::-webkit-scrollbar { 
        width:8px; 
        height:12px; 
        background:#ccc; 
        border-radius:10px;/*外层轨道*/
    }
    .bar-warp::-webkit-scrollbar-thumb{ /*内层轨道*/
        display:block; 
        width:4px; 
        margin:0 auto; 
        border-radius: 10px; 
        background:rgba(255, 192, 66, 0.3);
    }
    .bar{
        position:absolute;
        border-radius: 6px;
        cursor: pointer;
    }
    .link{
        position:absolute;
        height: 1px;
        /* z-index: 999; */
        transform-origin: 0 0;
        background: red;
    }
    .label {
        display: inline-block;

        height: 32px;
        line-height: 32px;
        font-size: 12px;
        color: #606266;

    }

    .value {
        display: inline-block;
        width: 200px;
        /* height: 32px; */
        line-height: 32px;
        font-size: 12px;
        color: #606266;
        vertical-align: top;
    }
    .border{
        border: 1px solid rgb(220,223,230);
    }
    .item{
        height: 74px;
        text-align: center;
        width:100px;
        line-height: 74px;
        box-sizing: border-box;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    
    .plan-text{
        display: inline-block;
        width: 40px;
        height: 37px;
        line-height: 37px;
        box-sizing: border-box;
        border-top: none;
        font-size: 12px;
        color: #909399;
        text-align: center;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    .day-item{
        flex:1;
        line-height:37px;
        text-align: center;
        border-right:none;
        border-bottom: none;
        box-sizing: border-box;
        position: relative;
    }
    .day-item::after {
        content: "";
        position: absolute; 
        top: 36px;
        right: -1px;
        width:1px;
        height:5900px;
        background: rgb(220,223,230);
    }
    .device-item{
        position: relative;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
    }
    .device-item::after{
        content: "";
        position: absolute; 
        top: 73px;
        left: 240px;
        width:11600px;
        height:1px;
        background: rgb(220,223,230);
        
    }
    .table-head{
        display: flex;
    }

    .table-time-warp{
        display: flex;
        height: 74px;
        box-sizing: border-box;
        font-size: 12px;
        color: #909399;
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
        z-index: 4;
        background:white;
        position: relative;
    }

    .table-body{
        display: flex;
        overflow: hidden;
    }
    .devcie-info {
        width: 340px;
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
    }
    .tab-head{
        width: 100%;
        /* border: 1px solid #ccc;
        display:flex;
        height: 66px;
        line-height: 66px;
        box-sizing: border-box;
        border-bottom: none; */
    }

    .tab{
        display:flex
    }

    .user-list{
        width:210px;
        margin-right:20px;
        position: relative;
        padding: 10px 0px;
    }
    .user-list::after{
        content: "";
        position: absolute; 
        top: 0px;
        right: -4px;
        width:18px;
        height:106%;
        background: #f6f7fa;
        
    }

    .gantt-list{
        width: 100%;
    }
    .left-item{
        width: 230px;
        border-right: 1px solid#ccc;
        box-sizing: border-box;
        text-align: center;
    }
    .right-item{
        display: flex;
        align-items: center;
        margin: 12px 0;
        justify-content: flex-end;
    }
    .scale-select{
        margin-left: 40px;
        width: 244px;
        height: 26px;
        display: flex;
        
       
    }
    .scale-select div{
        flex: 1;
        text-align: center;
        line-height: 26px;
        border: 1px solid #ccc;
        border-right: none;
        cursor: pointer;
        font-size: 14px;
    }
    .scale-select .border-ringht{
        border-right: 1px solid #ccc;
    }

    .explain{
        margin-left: 60px;
        line-height: 100%;
        display: flex;
    }
    .explain .explain-item{
        display: flex;
        margin-right: 40px;
    }
    .explain .explain-item div{
        width: 34px;
        height: 20px;
    }
    .explain .explain-item span{
        margin-left: 12px;
        font-size: 12px;
        line-height: 20px;
    }
    .select-box{
        margin-left: 200px
    }




    .top{
        width: 100%;
        height: 50px;
        background: #ffff;
        margin-top: 0px;
        padding-top: 15px;
    }
    .tabs{
        padding: 5px 20px;
        
    }

    .table_searchbar{
        padding: 15px 20px 0px 20px;
    }
    .content{
        /* width: 102.6%; */
        height: auto;
        margin-top: 20px;
        display: flex;
    }

    .workOrder-deviceTop{
        flex: 1;
        background: #fff;
        padding: 0 20px;
    }

    .summary span{
        font-size: 14px;
        margin-right: 20px;
    }
    #device-gantt{
        overflow: hidden;
        overflow-y: auto;
        width: 102.6%;
        scrollbar-width: none;
       
        margin-left: -20px;
        margin-top:-20px;
        /* background: #f6f7fa; */
        height: 102.5%;
    }
    #device-gantt::-webkit-scrollbar {
        display: none;
    }

    .search-input-row{
        margin-top: 10px;
    }
    .page{
        display: flex;
        justify-content: flex-end;
    }
    .total_page{
        margin-top: 16px;
        margin-right: 16px;
        color:#606266;
        font-size: 14px;
    }
    @media screen and (max-width: 1380px){
        .page{
            display: flex;
            justify-content: flex-end;
            margin-bottom:30px;
        }

        .summary span{
            font-size: 12px;
        }
    }
    @media screen and (max-width: 1440px) {
        #device-gantt{
            width: 103.6%;
        }
    }
    @media screen and (max-width: 1366px) {
        #device-gantt{
            width: 103.8%;
            height: 110%;
        }
        .content{
            padding-bottom: 40px
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 180px !important;
        }

        .scale-select{
            margin-left: 20px;
            width: 164px;
        }
        .explain .explain-item span{
        font-size: 12px;
        line-height:20px;
        }
        /* .explain .explain-item div {
            margin-top: 6px;
            width: 24px;
        } */
        .el-checkbox{
            margin-right: 20px;
        }
        .select-box{
            margin-left: 0px
        }
        .left-item{
            width: 190px;
        }
    }
    @media screen and (max-width: 1280px){
        #device-gantt{
            width: 104.2%;
        }
        .number-item {
            padding: 0 6px;
        }
        .number-item span{
            font-size: 26px
        }
        .hour{
            font-size: 14px;
            width: 28px;
        }
        .left-item{
            width: 170px;
        }
        .explain .explain-item{
            margin-right: 30px
        }
        .explain{
            margin-left:20px
        }
    }
    .detail-warp{
        font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC","Microsoft YaHei";
        display: flex;
        margin: 20px 30px;
    }
    .detail-item{
        display: flex;
        flex-direction: column;
        font-size: 12px;
        color: #606266;
        align-items: center;
    }
    .detail-head{
        width: 100px;
    }
    .detail-body{
        width: 180px;
    }
    .detail-item div{
        border: 1px solid #ccc;
        width: 100%;
        text-align: center;
    }
    .detail-item span{
        line-height: 50px;
        margin: 0 4px;
    }
    
    
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }

.left-container {
    height: 640px;
}


 .select_width{
    width: 210px;
}
#device-gantt .el-tree >.el-tree-node{
    margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/views/gantt/orderGantt.vue